import { useParams } from "react-router"

import { isAdminEntityUnavailable } from "@/modules/admin/utils/is-admin-entity-unavailable"
import { isUnavailableUserError, useUser } from "@/services/user"
import { parseModelId } from "@/utils/parse-model-id"

export const useAdminUserPageState = () => {
  const { userId: userIdParam } = useParams()

  const userId = parseModelId(userIdParam)

  const {
    userData,
    userError,
    userIsFetched,
    userIsFetching,
    userIsLoading,
    ...userQueryResult
  } = useUser({
    userId: userId === undefined ? null : String(userId),
    queryOptions: {
      enabled: userId !== undefined,
    },
  })

  const userIsUnavailable = isAdminEntityUnavailable({
    data: userData,
    error: userError,
    id: userId,
    isFetched: userIsFetched,
    isUnavailableError: isUnavailableUserError,
  })

  return {
    ...userQueryResult,
    userData,
    userError,
    userId,
    userIsFetched,
    userIsFetching,
    userIsLoading,
    userIsUnavailable,
  }
}
